import { render, staticRenderFns } from "./UsageContent.vue?vue&type=template&id=22f22c36&scoped=true"
import script from "./UsageContent.vue?vue&type=script&lang=js"
export * from "./UsageContent.vue?vue&type=script&lang=js"
import style0 from "./UsageContent.vue?vue&type=style&index=0&id=22f22c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f22c36",
  null
  
)

export default component.exports